export enum ExportReportFileType {
  PDF = 1,
  PDF_FORM = 2,
  PDF_DIGITAL_SIGNATURE_TEMPLATE = 3,
  XLSX = 4,
  XLSX_FORM = 5,
  JSON = 6,
  JSON_FORM = 7,
  ZIP = 8
}

export enum ExportReportFileValue {
  Json = 'json',
  Pdf = 'pdf',
  Zip = 'zip',
  Excel = 'xlsx'
}

export enum ExportReportFileLabel {
  Json = 'JSON',
  Pdf = 'PDF',
  Zip = 'ZIP',
  Excel = 'EXCEL'
}

export enum ExportReportFormFileLabel {
  Json = 'jsonForm',
  Pdf = 'pdfForm',
  Excel = 'xlsxForm'
}
